export default __webpack_public_path__ + "static/media/fondoIntegracion.682e9de4.jpg";